import { getGraphql } from '../static/graphql/getGraphql.js'

export const state = () => ({
  loading: [],
  contracts: [],
  familyContracts: [],
  familyMembers: [],
})

export const mutations = {
  setLoading(state, payload) {
    state.loading.push(payload.key)

    // unique the array
    state.loading = [...new Set(state.loading)]

    // remove
    if (!payload.value) {
      state.loading = state.loading.filter((e) => e !== payload.key)
    }
  },
  clearData(state) {
    state.loading = []
    state.contracts = []
    state.familyContracts = []
    state.familyMembers = []
  },
  addFamilyMember(state, payload) {
    const family = payload.family
    state.familyMembers.push({
      family_entity: family.entityUuid,
      name: family.name,
      members: family.relationships.hasMember,
    })
  },
  addFamilyContract(state, payload) {
    // parse contract and family
    const contract = payload.contract
    const family = payload.family

    const meta = JSON.parse(contract.campaignMeta)
    const parsedMeta = JSON.parse(meta)
    const contractMeta = JSON.parse(contract.meta)
    const localization = parsedMeta.localization || false
    const perm =
      family.permissions && family.permissions.length ? family.permissions : ''
    const fundApplicationDate =
      contract.applicationSubmittedDate[0]?.dateCreated
    state.familyContracts.push({
      contract_uuid: contract.contractUuid,
      offer_uuid: contract.offerUuid,
      name: contract.name,
      campaign_meta: parsedMeta,
      meta: contractMeta,
      permission: perm,
      localization,
      contract_status: contract.contractStatusId,
      created_by: contract.createdByEntityUuid,
      recipient_uuid: contract.recipientUuid,
      date_created: contract.dateCreated,
      date_updated: contract.dateUpdated,
      payments: contract.payments.slice(),
      fund_application_date: fundApplicationDate,
    })
  },
  addContract(state, payload) {
    const contract = payload.contract

    const meta = JSON.parse(contract.campaignMeta)
    const contractMeta = JSON.parse(contract.meta)
    const parsedMeta = JSON.parse(meta)
    const localization = parsedMeta.localization || false
    const fundApplicationDate =
      contract.applicationSubmittedDate[0]?.dateCreated
    state.contracts.push({
      contract_uuid: contract.contractUuid,
      name: contract.name,
      offer_uuid: contract.offerUuid,
      campaign_meta: parsedMeta,
      meta: contractMeta,
      localization,
      contract_status: contract.contractStatusId,
      created_by: contract.createdByEntityUuid,
      recipient_uuid: contract.recipientUuid,
      date_created: contract.dateCreated,
      date_updated: contract.dateUpdated,
      payments: contract.payments.slice(),
      fund_application_date: fundApplicationDate,
    })
  },
}

export const actions = {
  async getContracts(context) {
    try {
      context.commit('clearData')
      context.commit('setLoading', { key: 'getContracts', value: true })

      const query = await getGraphql('my-contracts.graphql')
      const response = await this.$axios.$post('/GRAPHQL_URL/', {
        query,
      })

      // parse individual contracts
      const contracts = response.data.me.relationships.myself[0].contracts
      if (contracts && contracts.length > 0) {
        for (let j = 0; j < contracts.length; j++) {
          context.commit('addContract', { contract: contracts[j] })
        }
      }

      // parse family contracts
      const families = response.data.me.relationships.memberOf
      if (families && families.length > 0) {
        for (let i = 0; i < families.length; i++) {
          if (families[i].contracts && families[i].contracts.length) {
            const contractsForFam = families[i].contracts
            for (let j = 0; j < contractsForFam.length; j++) {
              context.commit('addFamilyContract', {
                contract: contractsForFam[j],
                family: families[i],
              })
            }
          }

          if (
            families[i].relationships.hasMember &&
            families[i].relationships.hasMember.length
          ) {
            context.commit('addFamilyMember', { family: families[i] })
          }
        }
      }
    } catch (e) {
      console.log('Error getting contracts', e)
    } finally {
      context.commit('setLoading', { key: 'getContracts', value: false })
    }

    console.log('*** exiting getContracts ***')
  },
  async terminateContract(context, args) {
    const contractUuid = args.contractUuid
    const contractStatus = args.contractStatus
    const terminatedReason = args.terminatedReason
    const relationshipPermission = args.relationshipPermission
    let result

    if (contractStatus.length && contractUuid.length) {
      context.commit('setLoading', { key: 'terminateContract', value: true })
      const mutationQuery = await getGraphql('update-contract-status.graphql')

      const variables = {
        entityArgs: {
          contractStatus,
          contractUuid,
          terminatedReason,
          relationshipPermission,
        },
      }
      try {
        const response = await this.$axios.$post('/GRAPHQL_URL/', {
          query: mutationQuery,
          variables,
        })

        console.log('update contract', response)
        result = response
      } catch (e) {
        console.log(e)
      } finally {
        context.commit('setLoading', { key: 'terminateContract', value: false })
      }
    }

    return result
  },
}

export const getters = {
  findNextPayment: () => (payments, locale) => {
    let paymentDate = ''
    const options = {
      weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    }
    const localeString = locale.toLowerCase() === 'es' ? 'es-US' : 'en-US'
    if (payments) {
      for (let i = 0; i < payments.length; i++) {
        if (
          payments[i].paymentStatusId === 1 &&
          new Date() < new Date(payments[i].datePaymentFulfilled)
        ) {
          paymentDate = payments[i].datePaymentFulfilled
          break
        }
      }
      if (paymentDate.length) {
        paymentDate = new Date(paymentDate).toLocaleDateString(
          localeString,
          options
        )
      }
    }
    return paymentDate
  },
}
